var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('button',{staticClass:"btn-primary w-100",on:{"click":_vm.openDoc}},[_vm._v("Open Pending Documents")])])}
var staticRenderFns = []

export { render, staticRenderFns }